'use client'
import { useEffect } from 'react'
import { hotjar } from 'react-hotjar'

const NEXT_PUBLIC_HOTJAR_ID = process.env.NEXT_PUBLIC_HOTJAR_ID

const Hotjar = () => {
	useEffect(() => {
		if (!NEXT_PUBLIC_HOTJAR_ID) {
			console.log('Hotjar ID is not defined')
			return
		}

		console.log('Hotjar initialized')

		hotjar.initialize({ id: Number(NEXT_PUBLIC_HOTJAR_ID), sv: 6 })
	}, [])

	return <></>
}

export default Hotjar
